import Termly from 'termly-namespace'

import getCategoryForSrc from './getCategoryForSrc'


/**
 * Notes what `node` answers to, now that it has been allowed to load. A later
 * consent change cannot un-run it, and this is what tells us a reload is the
 * only way to enforce that change.
 *
 * @param {Element} node
 * @param {string} [src] - the incoming address, when one is being assigned
 */
export default function recordLoadedCategories(node, src) {
  const address = src || node.getAttribute('src')
  const category = node.dataset.categories || getCategoryForSrc(address)

  Termly.addLoadedCategories(category.split(','))
}
